import { maybe, cast } from "@flockcover/flock-svc-core-types"
import * as t from "io-ts"

const FleetEntryWithMileageType = t.type({
  vrn: maybe(t.string),
  name: maybe(t.string),
  mileage: maybe(t.number),
  isConnected: t.boolean,
})

export type FleetEntryWithMileage = t.TypeOf<typeof FleetEntryWithMileageType>
export const makeFleetEntriesWithMileage = cast(t.readonlyArray(FleetEntryWithMileageType))

const fleetEntriesMileageKeys = [`vrn`, `mileage`, `name`, `isConnected`] as const
export const fleetEntriesMileageKeysMap = new Map<FleetEntriesMileageSortKeysFE, FleetEntriesMileageSortKeys>([
  [fleetEntriesMileageKeys[0], fleetEntriesMileageKeys[0]],
])

export type FleetEntriesMileageSortKeys = (typeof fleetEntriesMileageKeys)[number]
export const fleetEntriesMileageKeysValue = fleetEntriesMileageKeys
export type FleetEntriesMileageSortKeysFE = (typeof fleetEntriesMileageKeysValue)[number]
